import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    auditActions: {
      tableData: [],
      totalAuditActions: 0
    },
    queryAuditActions: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      dateTimeFrom: fn.initDateFromAudit(0),
      dateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersAuditActions: [],
    optionsFilterUser: [],
    optionsFilterAction: [],
    optionsFilterGroup: []
  }
  return session
}
function initLocal () {
  const local = {
    // Acciones
    isShowServicioAuditoriaAct: true,
    isShowUserAuditoriaAct: true,
    isShowDateAuditoriaAct: true,
    isShowActionAuditoriaAct: true,
    isShowGroupAuditoriaAct: true,
    isShowValueAuditoriaAct: true
  }
  return local
}
function setByUserLocalAuditAction () {
  const local = {
    isShowServicioAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowServicioAuditoriaAct,
    isShowUserAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowUserAuditoriaAct,
    isShowDateAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowDateAuditoriaAct,
    isShowActionAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowActionAuditoriaAct,
    isShowGroupAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowGroupAuditoriaAct,
    isShowValueAuditoriaAct: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).auditoriaAcciones.isShowValueAuditoriaAct
  }
  return local
}

const state = {
  userConfigLocalStorage: '',
  local: {
    isShowServicioAuditoriaAct: true,
    isShowUserAuditoriaAct: true,
    isShowDateAuditoriaAct: true,
    isShowActionAuditoriaAct: true,
    isShowGroupAuditoriaAct: true,
    isShowValueAuditoriaAct: true

  },
  session: initSession()
}
const getters = {
  auditActions: state => {
    return state.session.auditActions
  },
  queryAuditActions: state => {
    return state.session.queryAuditActions
  },
  listSelectedFiltersAuditActions: state => {
    return state.session.listSelectedFiltersAuditActions
  },
  optionsFilterUser: state => {
    return state.session.optionsFilterUser
  },
  optionsFilterAction: state => {
    return state.session.optionsFilterAction
  },
  optionsFilterGroup: state => {
    return state.session.optionsFilterGroup
  },
  isShowServicioAuditoriaAct: state => {
    return state.local.isShowServicioAuditoriaAct
  },
  isShowUserAuditoriaAct: state => {
    return state.local.isShowUserAuditoriaAct
  },
  isShowDateAuditoriaAct: state => {
    return state.local.isShowDateAuditoriaAct
  },
  isShowActionAuditoriaAct: state => {
    return state.local.isShowActionAuditoriaAct
  },
  isShowGroupAuditoriaAct: state => {
    return state.local.isShowGroupAuditoriaAct
  },
  isShowValueAuditoriaAct: state => {
    return state.local.isShowValueAuditoriaAct
  }
}

const actions = {

  // Crear key Usuario
  setUserNameAuditAction ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalAuditAction()
    }
  },

  isNewVersionAuditoriaAccionesLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.auditoriaAcciones)
  },
  /**
     * Servicio para traer las AuditoriaAct.
     * Se utiliza también para ordenar la tabla, la paginación,
     * el tamaño de la tabla y los filtros.
     */
  async getAuditActions ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/auditaction',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      commit('AUDIT_ACTIONS_STATE', {
        tableData: response.data.content,
        totalAuditActions: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de usuarios
     * Auditorías
     */
  async getOptionsFilterUser ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/constant/users',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      const optionsFilterUser = response.data
      commit('OPTIONS_FILTER_USER_STATE', optionsFilterUser)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterUser
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de acciones
     * Auditorías
     */
  async getOptionsFilterAction ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/actions',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      const optionsFilterAction = response.data
      commit('OPTIONS_FILTER_ACTION_STATE', optionsFilterAction)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterAction
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
    * Servicio para llenar Select Filtro de grupo funcional
    * Auditorías
    */
  async getOptionsFilterGroup ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/groups',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      const optionsFilterGroup = response.data
      commit('OPTIONS_FILTER_GROUP_STATE', optionsFilterGroup)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterGroup
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  auditActionsState: ({
    commit
  }, payload) => {
    commit('AUDIT_ACTIONS_STATE', payload)
  },
  queryAuditActionsState: ({
    commit
  }, payload) => {
    commit('QUERY_AUDIT_ACTIONS_STATE', payload)
  },
  listSelectedFiltersAuditActionsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_AUDIT_ACTIONS_STATE', payload)
  },
  optionsFilterUserState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_USER_STATE', payload)
  },
  optionsFilterActionState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_ACTION_STATE', payload)
  },
  optionsFilterGroupState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_GROUP_STATE', payload)
  },
  isShowServicioAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_AUDITORIA_ACTIONS', payload)
  },
  isShowUserAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_USER_AUDITORIA_ACTIONS', payload)
  },
  isShowDateAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_AUDITORIA_ACTIONS', payload)
  },
  isShowActionAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ACTION_AUDITORIA_ACTIONS', payload)
  },
  isShowGroupAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_GROUP_AUDITORIA_ACTIONS', payload)
  },
  isShowValueAuditoriaActAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VALUE_AUDITORIA_ACTIONS', payload)
  }
}

const mutations = {
  resetSessionAuditoriaAcciones (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  auditsDatesSUperAdmin (state) {
    state.session.queryAuditActions.dateTimeFrom = fn.initDateFromAudit(0)
  },
  'AUDIT_ACTIONS_STATE' (state, payload) {
    state.session.auditActions = payload
  },
  'QUERY_AUDIT_ACTIONS_STATE' (state, payload) {
    state.session.queryAuditActions = payload
  },
  'LIST_SELECTED_FILTERS_AUDIT_ACTIONS_STATE' (state, payload) {
    state.session.listSelectedFiltersAuditActions = payload
  },
  'OPTIONS_FILTER_USER_STATE' (state, payload) {
    state.session.optionsFilterUser = payload
  },
  'OPTIONS_FILTER_ACTION_STATE' (state, payload) {
    state.session.optionsFilterAction = payload
  },
  'OPTIONS_FILTER_GROUP_STATE' (state, payload) {
    state.session.optionsFilterGroup = payload
  },
  'IS_SHOW_SERVICIO_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowServicioAuditoriaAct = !!payload
    const key = state.userConfigLocalStorage
    // leer y crear estructura segura
    let storeuser = null
    try {
      storeuser = JSON.parse(localStorage.getItem(key)) || {}
    } catch (e) {
      storeuser = {}
      console.log('error', e)
    }
    if (!storeuser.auditoriaAcciones) {
      storeuser.auditoriaAcciones = {
        isShowServicioAuditoriaAct: false,
        isShowUserAuditoriaAct: true,
        isShowDateAuditoriaAct: true,
        isShowActionAuditoriaAct: true,
        isShowGroupAuditoriaAct: true,
        isShowValueAuditoriaAct: true
      }
    }
    storeuser.auditoriaAcciones.isShowServicioAuditoriaAct = !!payload
    localStorage.setItem(key, JSON.stringify(storeuser))
  },
  'IS_SHOW_USER_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowUserAuditoriaAct = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditoriaAcciones.isShowUserAuditoriaAct = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowDateAuditoriaAct = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditoriaAcciones.isShowDateAuditoriaAct = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ACTION_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowActionAuditoriaAct = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditoriaAcciones.isShowActionAuditoriaAct = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROUP_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowGroupAuditoriaAct = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditoriaAcciones.isShowGroupAuditoriaAct = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VALUE_AUDITORIA_ACTIONS' (state, payload) {
    state.local.isShowValueAuditoriaAct = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.auditoriaAcciones.isShowValueAuditoriaAct = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
